export default __webpack_public_path__ + "collapse-window-option.png";